<template>
  <div style="display:none"></div>
</template>

<script>
import { isWhiteLabel } from "../utils/whitelabel";
export default {
  name: "WhatsAppFab",
  computed: {
    whiteLabel() { return isWhiteLabel(); },
  },
  watch: {
    // El FAB se inyecta a mano en el body, así que no alcanza un v-if:
    // lo montamos o lo sacamos cuando cambia el flag (p. ej. al pasar a
    // una radio de reseller sin recargar la página).
    whiteLabel(on) {
      if (on) this.removeFab();
      else this.renderFab();
    },
  },
  mounted() {
    this.renderFab();
  },
  methods: {
    removeFab() {
      const el = document.getElementById("__wa_fab__");
      if (el && el.parentNode) el.parentNode.removeChild(el);
    },
    renderFab() {
    // En marca blanca no montamos el FAB: el soporte del cliente de reseller
    // pasa por el reseller, no por nuestro WhatsApp.
    if (isWhiteLabel()) return;
    if (document.getElementById("__wa_fab__")) return;
    const a = document.createElement("a");
    a.id = "__wa_fab__";
    a.href = "https://wa.me/5491151427136";
    a.target = "_blank";
    a.rel = "noopener";
    a.setAttribute("aria-label", "Soporte por WhatsApp");
    a.title = "Soporte Inovanex";
    a.innerHTML = '<svg viewBox="0 0 32 32" width="30" height="30" aria-hidden="true"><path fill="#fff" d="M19.11 17.21c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.47-2.4-1.49-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.21 5.08 4.5.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35zM16.03 5.33C10.11 5.33 5.34 10.1 5.34 16c0 1.87.49 3.69 1.42 5.29L5.33 26.67l5.52-1.45a10.67 10.67 0 0 0 5.18 1.32c5.92 0 10.69-4.77 10.69-10.67 0-5.9-4.77-10.54-10.69-10.54zm0 19.25c-1.58 0-3.13-.42-4.48-1.22l-.32-.19-3.27.86.87-3.19-.21-.33a8.72 8.72 0 0 1-1.33-4.51c0-4.83 3.93-8.75 8.74-8.75 4.81 0 8.74 3.84 8.74 8.75 0 4.83-3.93 8.58-8.74 8.58z"/></svg>';
    Object.assign(a.style, {
      position: "fixed",
      right: "22px",
      bottom: "22px",
      width: "58px",
      height: "58px",
      borderRadius: "50%",
      background: "#25d366",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 8px 22px rgba(37,211,102,.38), 0 2px 6px rgba(0,0,0,.15)",
      zIndex: "2147483000",
      transition: "transform .18s ease, box-shadow .18s ease",
      textDecoration: "none"
    });
    a.addEventListener("mouseenter", () => { a.style.transform = "translateY(-2px)"; });
    a.addEventListener("mouseleave", () => { a.style.transform = ""; });
    document.body.appendChild(a);
    },
  },
  beforeDestroy() {
    this.removeFab();
  }
};
</script>
